import type { KeyboardEvent as ReactKeyboardEvent } from 'react'

/**
 * 日本語入力（IME）の変換を確定するためのキー押下かを判定する。
 *
 * 履歴タイトルの入力欄は「Enterで保存」だが、変換の確定のEnterまで保存にしてしまうと、
 * 「お父さん案」と打って変換を確定した時点で保存され、続きを打てない（岩下さんの指摘、2026-10-29）。
 * 変換の確定は除外し、確定後にもう一度Enterを押したときだけ保存する。
 *
 * 判定は2通りを併用する:
 * - `isComposing`: 変換中のキー押下でブラウザが立てる標準のフラグ
 * - `keyCode === 229`: Safariは変換確定のEnterで `compositionend` を先に発火し、
 *   keydownの時点では `isComposing` がfalseになる。そのkeydownは `keyCode` が229なので、こちらで拾う
 */
export const isImeComposingKeyEvent = (event: ReactKeyboardEvent<HTMLElement>): boolean =>
  event.nativeEvent.isComposing || event.nativeEvent.keyCode === 229
